import * as React from 'react';
import { BreadcrumbNavigation } from './Breadcrumb';

export interface BreadcrumbContextType {
  breadcrumb: BreadcrumbNavigation | null;
  setBreadcrumb: (breadcrumb: BreadcrumbNavigation | null) => void;
}

export const BreadcrumbContext = React.createContext<BreadcrumbContextType | undefined>(undefined);

export const BreadcrumbProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [breadcrumb, setBreadcrumb] = React.useState<BreadcrumbNavigation | null>(null);
  const context = { breadcrumb, setBreadcrumb };

  return <BreadcrumbContext.Provider value={context}>{children}</BreadcrumbContext.Provider>;
};

export default BreadcrumbProvider;
